// COM-HUBS (2026-08-21): Painel — Dashboard + Metas (+ Onde a Hydrodata ganha, desde 16/10/2026).
// Fica na raiz `/comercial` (era o path do Dashboard), então todo link antigo
// pro módulo continua caindo aqui.
import HubAbas, { HubTab } from '../../components/HubAbas';
import ComercialDashboard from '../ComercialDashboard';
import ComercialMetas from '../ComercialMetas';
import OndeGanha from '../comercial-onde-ganha/OndeGanha';

const TABS: HubTab[] = [
  { key: 'dashboard', label: '📊 Dashboard', perm: 'comercial.dashboard.ver', render: () => <ComercialDashboard /> },
  { key: 'onde-ganha', label: 'Onde a Hydrodata ganha', perm: 'comercial.dashboard.ver', render: () => <OndeGanha /> },
  { key: 'metas',     label: '🎯 Metas',     perm: 'comercial.metas.ver',     render: () => <ComercialMetas /> },
];

export default function ComercialPainelHub() {
  return <HubAbas tabs={TABS} />;
}
